<template>
  <div class="ProseMirror" v-html="output"></div>
</template>

<script>
import {generateHTML} from '@tiptap/core'
import Typography from '@tiptap/extension-typography'
import Dropcursor from "@tiptap/extension-dropcursor";
import Gapcursor from "@tiptap/extension-gapcursor";
import Document from "@tiptap/extension-document";

export default {
  name: "RichTextView",
  props: {
    content: [Object, String],
    features: Array
  },
  data() {
    return {
      output: ""
    }
  },
  watch: {
    content: {
      immediate: true,
      deep: true,
      handler() {
        if (this.content) {
          this.output = generateHTML(this.content, this.extensions);
        } else {
          this.output = "";
        }
      }
    }
  },
  computed: {
    extensions() {
      let list = [
        Typography,
        Dropcursor,
        Gapcursor,
        Document
      ];

      this.features.forEach(feature => {
        feature.getExtensions({ slots: this.$slots }).forEach(extension => {
          if (!list.includes(extension)) list.push(extension);
        });
      });
      return list;
    }
  }
}
</script>